export default __webpack_public_path__ + "static/media/data_(4)_seguimiento.e4625437.png";